import * as styles from "./FieldError.css";

import { clsx } from "clsx";
import { type JSX, useState } from "react";

import { Field as BaseField } from "@base-ui/react/field";
import { Tooltip, TooltipContent } from "@frontend/components/atoms/Tooltip";

import { fieldControl, useFieldErrorTooltip } from "./Field.context";
import type { FieldErrorProps } from "./Field.types";

export function FieldError({
  className,
  children,
  ...props
}: FieldErrorProps): JSX.Element {
  const tooltip = useFieldErrorTooltip();

  const [node, setNode] = useState<HTMLElement | null>(null);

  const error = (
    <BaseField.Error
      ref={tooltip ? setNode : undefined}
      data-slot="field-error"
      className={clsx(tooltip ? styles.hidden : styles.error, className)}
      {...props}
    >
      {children}
    </BaseField.Error>
  );

  if (!tooltip) {
    return error;
  }

  return (
    <>
      {error}

      <Tooltip open={null !== node && tooltip.active}>
        <TooltipContent
          variant="error"
          anchor={() => fieldControl(tooltip.anchor.current)}
          side="top"
          align="center"
        >
          {children}
        </TooltipContent>
      </Tooltip>
    </>
  );
}
